import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "houzz",
  "use": "houzz-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"houzz\"><path fill-rule=\"evenodd\" d=\"M24 0v24H0V0zM8.5 5H5v15h5v-5h3.5v5h5v-8.63L8.5 8.5z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol